import React from 'react';
import { IconButton as MuiIconButton } from '@mui/material';
import './IconButton.scss';

export type IconButtonVariant = 'default' | 'primary' | 'ghost';
export type IconButtonSize = 'small' | 'medium' | 'large';

export interface IconButtonProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  ariaLabel: string;
  size?: IconButtonSize;
  variant?: IconButtonVariant;
  disabled?: boolean;
  className?: string;
}

export const IconButton: React.FC<IconButtonProps> = ({
  children,
  onClick,
  ariaLabel,
  size = 'medium',
  variant = 'default',
  disabled = false,
  className,
}) => {
  return (
    <MuiIconButton
      data-component="IconButton"
      data-variant={variant}
      aria-label={ariaLabel}
      size={size}
      onClick={onClick}
      disabled={disabled}
      className={className}
    >
      {children}
    </MuiIconButton>
  );
};
